export const ACCEPT_TERMS = 'ACCEPT_TERMS';

export const EMPTY_CART = 'EMPTY_CART';
export const ADD_CART_ITEMS = 'ADD_CART_ITEMS';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const UPDATE_CART_DISCOUNT = 'UPDATE_CART_DISCOUNT';
export const UPDATE_BOOKER = 'UPDATE_BOOKER';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const UPDATE_ITEM_GUEST = 'UPDATE_ITEM_GUEST';
export const ADD_ADDON = 'ADD_ADDON';

export const SET_SUCCESS = 'SET_SUCCESS';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_AS_CUSTOMER = 'LOGIN_AS_CUSTOMER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const REFRESH_USER_CAPABILITIES = 'REFRESH_USER_CAPABILITIES';

export const SET_CARD_TOKEN = 'SET_CARD_TOKEN';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';

export const ACTIVITY_BOOKING_NOTE_ACCEPTED = 'ACTIVITY_BOOKING_NOTE_ACCEPTED';

export const SET_CART_ITEM_AGENTNOTE = 'SET_CART_ITEM_AGENTNOTE';

export const SET_CART_ITEM_CUSTOM_BOOKING = 'SET_CART_ITEM_CUSTOM_BOOKING';
export const SET_CART_ITEM_HAS_CUSTOM_BOOKING = 'SET_CART_ITEM_HAS_CUSTOM_BOOKING';

export const ADD_ACTIVITY_TO_COMPARE_LIST = 'ADD_ACTIVITY_TO_COMPARE_LIST';
export const REMOVE_ACTIVITY_FROM_COMPARE_LIST = 'REMOVE_ACTIVITY_FROM_COMPARE_LIST';
export const CLEAR__COMPARE_LIST = 'CLEAR__COMPARE_LIST';
